import "./css/app.css"
import Footer from "./../footer/footer"

const Apply = () => {
    return (
        <div className="pageWrapper">
            <div className="appMainContainer">
                <div className="appMessageBox">
                    <div className="appIcon">
                        <i className="fa-solid fa-bell"></i>
                    </div>
                    <h3>Job & Exam Alerts</h3>
                    <div className="appMessage">
                        We provide a centralized platform for government job notifications, college admissions, 
                        exam date alerts, results, and more. By registering with your qualifications, location, age, and 
                        other relevant details, you can receive personalized email alerts tailored to your profile.
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}
export default Apply